import React from 'react';
import { useTranslation } from 'react-i18next';
import packageJson from '../../package.json';
import './Footer.scss';

const TERMS_CONDITIONS_URL = process.env.REACT_APP_TERMS_CONDITIONS_URL;

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const hasTermsUrl = TERMS_CONDITIONS_URL && TERMS_CONDITIONS_URL.trim() !== '';

  return (
    <footer className="app-footer">
      <div className="app-footer__container">
        <div className="app-footer__content">
          <span className="app-footer__copyright">
            © {currentYear} Viamericas. All rights reserved.
          </span>
          {hasTermsUrl && (
            <a
              href={TERMS_CONDITIONS_URL}
              className="app-footer__terms-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('footer.termsAriaLabel')}
            >
              {t('footer.termsAndConditions')}
            </a>
          )}
          <span className="app-footer__version">
            v{packageJson.version}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
